import { UserDTO } from 'models'
import { Constraints } from '@touche-lts/panel-ui/dist'

export const userDtoConstraints: Constraints<UserDTO> = {
  emailAddress: {
    presence: true,
    email: true,
    length: { minimum: 2, maximum: 50 }
  },
  firstName: {
    presence: true,
    length: { minimum: 2, maximum: 50 }
  },
  lastName: {
    presence: true,
    length: { minimum: 2, maximum: 50 }
  },
  role: {
    presence: true
  }
  // userType: {
  //   presence: true,
  //   inclusion: userTypes
  // },
  // deviceOs: {
  //   inclusion: deviceOsTypes
  // },
  // deviceToken: {
  //   length: { maximum: 256 }
  // }
}
